import React from "react";
import { Canvas, useFrame } from "@react-three/fiber";
import * as THREE from "three";

export default function Ellipsoid() {
    // Generate an ellipsoid mesh using react-three-fiber
    const meshRef = React.useRef();
    const geometryRef = React.useRef();

    useFrame(() => {
        if (meshRef.current) {
            meshRef.current.rotation.y += 0.005;
            meshRef.current.rotation.x -= 0.005;
            meshRef.current.rotation.z += 0.005;
        }
    });

    React.useEffect(() => {
        // Scale the geometry, then center it
        if (geometryRef.current) {
            geometryRef.current.scale(1, 3, 2);
            geometryRef.current.computeBoundingBox();
            const center = geometryRef.current.boundingBox.getCenter(
                new THREE.Vector3()
            );
            geometryRef.current.translate(-center.x, -center.y, -center.z);
        }
    }, []);

    return (
        <mesh ref={meshRef} position={[0, 0, 0]}>
            <sphereGeometry ref={geometryRef} args={[15, 32, 16]} />
            <meshStandardMaterial
                color={0xa50000}
                emissive={1}
                roughness={0.35}
                metalness={0}
                // metalness={0.7}
                emissiveIntensity={3}
            />
        </mesh>
    );
}

export function EllipsoidScene() {
    return (
        <div className="world">
            <Canvas
                camera={{
                    position: [0, 0, 100],
                }}
            >
                <ambientLight />
                {/* <OrbitControls /> */}
                {/* <pointLight position={[10, 10, 10]} /> */}
                <directionalLight position={[-10, 10, 5]} />
                {/* <spotLight position={[10, -10, 10]} /> */}
                <Ellipsoid />
            </Canvas>
        </div>
    );
}
